// OPARINA promo bar rotation (Andrés 2026-10-27): one message at a time, every width. Progressive: the
// .oc-promo--rotate class (stacked layout) is only added here, so without JS the bar stays as before.
(() => {
  const start = (bar) => {
    if (bar.dataset.ready) return;
    const items = [...bar.children].filter((el) => el.tagName === 'P');
    if (items.length < 2) return;
    bar.dataset.ready = '1';
    bar.classList.add('oc-promo--rotate');
    const ms = Math.max(3, +bar.dataset.rotate || 5) * 1000;
    let i = 0;
    let paused = false;
    const show = (n) => items.forEach((el, k) => {
      el.classList.toggle('is-on', k === n);
      el.toggleAttribute('inert', k !== n);
      el.setAttribute('aria-hidden', k === n ? 'false' : 'true');
    });
    show(0);
    setInterval(() => {
      if (paused || document.hidden) return;
      i = (i + 1) % items.length;
      show(i);
    }, ms);
    const pause = () => { paused = true; };
    const play = () => { paused = false; };
    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', play);
    bar.addEventListener('focusin', pause);
    bar.addEventListener('focusout', play);
  };
  const init = () => document.querySelectorAll('.oc-promo[data-rotate]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
